import { styled } from '@mui/material';
import React from 'react';

const StyledIconBase = styled('div')({
  width: '32px',
  height: '32px',
  background: '#303746',
  borderRadius: '50%',
  flexShrink: 0,
  zIndex: '-2', // Keep element behind gradient
  '& > svg': {
    width: '100%',
    height: '100%',
  },
});

export const StyledIcon = (props: React.ComponentProps<'div'>) => {
  const { children, ...rest } = props;

  const baseProps = {
    'data-testid': 'StyledIcon',
  };

  return React.createElement(
    StyledIconBase,
    { ...baseProps, ...rest },
    children,
  );
};
